import { Amplify } from 'aws-amplify';
import { environment } from 'src/environments/environment';

export function awsInitializerFactory(): any {
  return () => {
    Amplify.configure(environment.amplify);
  };
}
